export default "__VITE_ASSET__6cdeb8d4__"